import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import styled from "styled-components";
import { useTranslation } from "react-i18next";

const PaymentPending = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [countdown, setCountdown] = useState(5);

  const message = searchParams.get("message") || 
                 t("payment_processing_please_wait");

  useEffect(() => {
    const timer = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          // Redirect back to signup to retry
          navigate("/signup?" + new URLSearchParams(searchParams).toString());
          clearInterval(timer);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [navigate, searchParams]);

  return (
    <PendingWrapper>
      <div className="pending-container">
        <div className="loader"></div>
        <h1>{t("processing_payment")}</h1>
        <p>{message}</p>
        <p className="countdown">
          {t("redirecting_in")} {countdown}s...
        </p>
      </div>
    </PendingWrapper>
  );
};

export default PaymentPending;

const PendingWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);

  .pending-container {
    text-align: center;
    background: white;
    padding: 60px 40px;
    border-radius: 10px;
    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);
    max-width: 500px;
    width: 90%;
  }

  .loader {
    border: 5px solid #f3f3f3;
    border-top: 5px solid #667eea;
    border-radius: 50%;
    width: 60px;
    height: 60px;
    animation: spin 1s linear infinite;
    margin: 0 auto 30px;
  }

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }

  h1 {
    color: #333;
    margin-bottom: 15px;
    font-size: 28px;
  }

  p {
    color: #666;
    font-size: 16px;
    line-height: 1.6;
    margin: 10px 0;
  }

  .countdown {
    color: #999;
    font-size: 14px;
    margin-top: 20px;
  }

  @media (max-width: 600px) {
    .pending-container {
      padding: 40px 20px;
    }

    h1 {
      font-size: 24px;
    }

    p {
      font-size: 14px;
    }

    .loader {
      width: 50px;
      height: 50px;
    }
  }
`;